import { StyleSheet } from 'aphrodite'
import { Colours } from '../../../../style_helpers'

export default StyleSheet.create({
  base: {
    display: 'inline-block',
    borderRadius: '5px'
  },

  light: {
    backgroundColor: Colours('white', 300),
    color: Colours('uiBlue', 300),

    ':hover': {
      backgroundColor: Colours('grey', 50),
      color: Colours('uiBlue', 400)
    },

    ':active': {
      backgroundColor: Colours('grey', 100),
      color: Colours('uiBlue', 500)
    }
  },

  dark: {
    backgroundColor: Colours('uiBlue', 300),
    color: Colours('white', 300),

    ':hover': {
      backgroundColor: Colours('uiBlue', 400),
      color: Colours('grey', 50)
    },

    ':active': {
      backgroundColor: Colours('uiBlue', 500),
      color: Colours('grey', 100)
    }
  },

  disabled: {
    pointerEvents: 'none',
    backgroundColor: Colours('grey', 100),
    color: Colours('grey', 200)
  }
})
